angular.module('admin', ['tandibar/ng-rollbar', 'ui.router', 'homebot.directives', 'homebot.filters', 'homebot.services', 'sharedservices', 'admin.services', 'admin.directives', 'ngCookies', 'ngAnimate', 'ngStorage', 'ngSanitize', 'jsonFormatter', 'bw.paging', 'text-mask', 'appTemplateCache', 'adminTemplateCache'])
  .config(['$stateProvider', '$urlRouterProvider', '$httpProvider', '$locationProvider', '$compileProvider', function($stateProvider, $urlRouterProvider, $httpProvider, $locationProvider, $compileProvider){
    $urlRouterProvider.otherwise("/start");

    $locationProvider.html5Mode(true);
  }])

  .constant('API_VARS',{
    path: window.HB_APP_CONFIG.API_URL + 'v1',
    app:'HomebotAdmin',
    loginTTL:28
  })

  .constant('APP_CONFIG', window.HB_APP_CONFIG)

  .constant('FEATURES', {
    DIGEST_V2: 'digest_v2',
    MORTGAGE_COACH: 'mortgage_coach_customer',
    ADMIN: 'legacy_customer_admin',
  })

  .config(['RollbarProvider', 'APP_CONFIG', function(RollbarProvider, APP_CONFIG) {
    if(!APP_CONFIG.ROLLBAR_ENV) return;

    RollbarProvider.init({
      accessToken: 'd601b21d78ec42e0a0d4e300c1d7933e',
      captureUncaught: true,
      captureUnhandledRejections: true,
      payload: {
        environment: APP_CONFIG.ROLLBAR_ENV,
      }
    });
  }])

  .config(['JSONFormatterConfigProvider', function(JSONFormatterConfigProvider){
    // Enable the hover preview feature
    JSONFormatterConfigProvider.hoverPreviewEnabled = true;
  }])

  // Add Authorization header to each request
  .config(['$httpProvider', function($httpProvider){
    $httpProvider.interceptors.push('AuthHeaderInterceptor');
  }])

  .run(['AccountService', 'SessionService', function(AccountService, SessionService){
    if(SessionService.isLoggedIn())
      AccountService.initIntercom();
  }])

  // Most often triggered by users that aren't logged in
  // See the `authenticated` blocks in the routers
  .run(['$rootScope', '$state', 'AuthForwarder', 'SessionService', 'PageNotificationService', function($rootScope, $state, AuthForwarder, SessionService, PageNotificationService){
    $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, options) {
      if(!SessionService.isLoggedIn()){
        if(toState.name !== 'agent.login'){
          const forwardState = $state.href(toState, toParams, {absolute: true})
          AuthForwarder.setForwardState(forwardState);
          $state.go('login');
        }
      }else{
        PageNotificationService.error('There was an error loading this page.');
      }
    });
  }])

  // Allow routes to be set to external urls
  .run(['$rootScope', '$window', 'APP_CONFIG', function($rootScope, $window, APP_CONFIG) {
    $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
      if(toState.external && !toState.waitForResolve){
        event.preventDefault();

        if (Object.keys(toParams).length > 0) {
          if (toState.externalUrl.includes("{groupId}") && toParams.groupId) {
            toState.externalUrl = toState.externalUrl.replace(`{groupId}`, toParams.groupId);
          }

          if (toState.externalUrl.includes("{homeId}") && toParams.homeId) {
            toState.externalUrl = toState.externalUrl.replace(`{homeId}`, toParams.homeId);
          }

          if (toState.externalUrl.includes("{clientId}") && toParams.clientId) {
            toState.externalUrl = toState.externalUrl.replace(`{clientId}`, toParams.clientId);
          }
        }

        if ((toState.externalUrl.indexOf(APP_CONFIG.MAINSTREET_URL) === 0) || (toState.externalUrl.indexOf(APP_CONFIG.CLIENTS_FRONTEND_URL) === 0)) {
          $window.open(toState.externalUrl, '_self');
        }
      }
    });

    // duplicate this on stateChangeSuccess to account for waiting for resolve functions
    // otherwise angular will navigate to the fallback (.otherwise) route
    // and create extra calls and an extra history item
    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams) {
      if(toState.external && toState.waitForResolve){
        event.preventDefault();

        if (Object.keys(toParams).length > 0) {
          if (toState.externalUrl.includes("{groupId}") && toParams.groupId) {
            toState.externalUrl = toState.externalUrl.replace(`{groupId}`, toParams.groupId);
          } else if (toState.externalUrl.includes("{homeId}") && toParams.homeId) {
            toState.externalUrl = toState.externalUrl.replace(`{homeId}`, toParams.homeId);
          }
        }

        if ((toState.externalUrl.indexOf(APP_CONFIG.MAINSTREET_URL) === 0) || (toState.externalUrl.indexOf(APP_CONFIG.CLIENTS_FRONTEND_URL) === 0)) {
          $window.open(toState.externalUrl, '_self');
        }
      }
    });
  }]);
